import React, { createContext, useMemo, useReducer } from 'react';
import { Action, TChildren } from '../typings/common';

export enum DeviceType {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
}

const getDeviceType = () => {
  const x =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.getElementsByTagName('body')[0].clientWidth;

  if (x < 768) {
    return DeviceType.MOBILE;
  }

  if (x >= 768 && x < 1024) {
    return DeviceType.TABLET;
  }

  return DeviceType.DESKTOP;
};

interface Props {
  children: TChildren;
}

interface IState {
  deviceType: DeviceType;
}

interface IContext {
  appState: IState;
  appDispatch: React.Dispatch<Action<ActionType>>;
}

const initialState: IState = {
  deviceType: getDeviceType(),
};

enum ActionType {
  SET_DEVICE_TYPE = 'SET_DEVICE_TYPE',
}

export const ActionCreator = {
  setDeviceType: () => ({
    type: ActionType.SET_DEVICE_TYPE,
    payload: getDeviceType(),
  }),
};

const reducer = (state: IState, action: Action<ActionType>): IState => {
  switch (action.type) {
    case ActionType.SET_DEVICE_TYPE:
      return { ...state, deviceType: action.payload as DeviceType };
    default:
      return state;
  }
};

export const AppContext = createContext<IContext>({
  appState: initialState,
  appDispatch: () => {},
});

const AppProvider: React.FC<Props> = ({ children }) => {
  const [appState, appDispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => ({ appState, appDispatch }), [appState]);

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export default AppProvider;
